<template>
  <b-modal
    ref="modalConfirmContainer"
    size="lg"
    dialog-class="!max-w-[600px]"
    body-class="!px-[16px] !py-[32px]"
    no-close-on-backdrop
    no-close-on-esc
    centered
    hide-footer
    hide-header
  >
    <b-img
      :src="statusImage"
      :alt="title"
      width="100"
      height="100"
      class="mx-auto mb-[16px]"
    />
    <h4 class="text-center text-[20px] font-semibold mt-[24px] mb-[16px] text-[#333333]">
      {{ title }}
    </h4>
    <p class="text-center font-[400] mb-[24px] text-[#626262]">
      {{ description }}
    </p>
    <div v-if="progress.show">
      <b-progress
        :value="progress.count"
        :max="progress.max"
        class="mb-[16px]"
      />
      <p class="text-center font-[400] mb-[24px] text-muted">
        {{ progress.text }}
      </p>
    </div>
    <div class="flex flex-row gap-[16px] -mb-[16px]">
      <b-button
        v-if="cancel.show"
        variant="outline-primary"
        class="w-full"
        @click="cancel.onClick"
      >
        {{ cancel.label }}
      </b-button>
      <b-button
        v-if="confirm.show"
        variant="primary"
        class="w-full !flex items-center justify-center gap-[8px]"
        :disabled="loading"
        @click="handleConfirm"
      >
        <b-spinner
          v-if="loading"
          class="inline-flex mr-[4px]"
          small
        />
        {{ confirm.label }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { MODAL_TYPE_ICON } from './config'

export default {
  name: 'ModalSelectAll',
  data() {
    return {
      statusImage: MODAL_TYPE_ICON.WARNING,
      title: 'Loading Proses Mapping',
      description: 'Proses mapping sedang berlangsung. Mohon tunggu sebentar ya.',
      loading: false,
      cancel: {
        show: false,
        label: 'Batal',
        onClick: () => {
          this.$emit('cancel')
        },
      },
      confirm: {
        show: false,
        label: 'Konfirmasi',
        onClick: () => {
          this.$emit('confirm')
        },
      },
      progress: {
        show: false,
        max: 0,
        text: '',
        count: 0,
      },
    }
  },
  methods: {
    /**
       * Show the modal confirm. This method used by the parent to show the modal confirm.
       * @param {Object} data - the data to show
       * @param {String} data.status - the status of the modal (WARNING, SUCCESS)
       * -- WARNING: used for warning modal
       * -- SUCCESS: used for success modal
       * @param {String} data.title - the title of the modal
       * @param {String} data.description - the description of the modal
       * @param {String} data.cancelLabel - the label of the cancel button (optional)
       * @param {String} data.confirmLabel - the label of the confirm button (optional)
       * @param {Function} data.onCancel - the function to call when the cancel button is clicked (optional)
       * @param {Function} data.onConfirm - the function to call when the confirm button is clicked (optional)
       * @param {Function} data.processFn - the function to call when the modal is shown (optional)
       * @param {Number} data.progressMax - the maximum value of the progress bar (optional)
       * @param {String} data.progressText - the text of the progress bar (optional)
       * @param {Number} data.processedCount - the current value of the progress bar (optional)
       */
    show({
      status,
      title,
      description,
      cancelLabel,
      confirmLabel,
      onCancel,
      onConfirm,
      processFn,
      progressMax,
      progressText,
      processedCount,
    }) {
      this.statusImage = MODAL_TYPE_ICON[status]
      this.title = title
      this.description = description
      this.cancel = {
        show: !!cancelLabel,
        label: cancelLabel,
        onClick: onCancel,
      }
      this.confirm = {
        show: !!confirmLabel,
        label: confirmLabel,
        onClick: onConfirm,
      }
      this.progress = {
        show: !!progressMax,
        max: progressMax,
        text: progressText,
        count: processedCount,
      }
      this.$refs.modalConfirmContainer.show()
      if (processFn) {
        processFn()
      }
    },
    /**
       * Update the progress of the bulk update process
       * @param {Object} data - the data to update the progress
       * @param {String} data.text - the text of the progress bar
       * @param {Number} data.count - the current value of the progress bar
       */
    updateProgress({ text, count }) {
      this.progress = {
        ...this.progress,
        text,
        count,
      }
    },
    /**
       * Handle the confirm button click
       */
    async handleConfirm() {
      this.loading = true
      await this.confirm.onClick()
      this.loading = false
    },
    /**
       * Hide the modal confirm
       */
    hide() {
      this.$refs.modalConfirmContainer.hide()
    },
  },
}
</script>
